import React from 'react';
import About from './About.js';

function Home() {
    return (
        <>
           <About />
        </>
    );
}

export default Home;